export default {
    route:{
        frame: 'frame'
    },
    project:{
        login: {
            projectName: '我有一个伟大的梦想',
            userAccount: '账  号',
            userAccountPlaceholder: '请输入账号',
            userPassword: '密  码',
            userPasswordPlaceholder:'请输入密码',
            VerificationCode: '验证码:',
            verificationCodePlaceholder:'请输入验证码',
            userLogin: '登录'
        },
        main:{
            menuLabel: '菜单标题',
            mainLabel: '主页标题'
        }
    },
    httpCode:{
        http404: '404 error'
    }
}